import axios from 'axios';

export async function handleRequest(type, url, data) {
    const responseData = await axios({
            method: type,
            url: url,
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            }
        });

    return responseData.data;
}

export async function handleJsonRequest(type, url, data) {
    const responseData = await axios({
            method: type,
            url: url,
            data: data,
            headers: {
                'Content-Type': 'application/json',
            }
        });

    return responseData.data;
}